
import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { getMedal } from "data/Querys";
import MirsTable from 'components/general/table/Table.js';
import Label from 'components/general/Label';
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import { ColumnOrganisation, ColumnNoc } from "components/common/TableColumns"
import PageHeader from 'components/common/PageHeader';
import { Stack } from 'react-bootstrap';
import SelectorDiscipline from 'components/common/selectors/selector-discipline/selectorDiscipline';
import SelectorNoc from 'components/common/selectors/selector-noc';
import { ALL_URL } from "helpers/utils";
import SelectorGender from 'components/common/selectors/selector-gender';
import Medal from 'components/presentation/Medal';


export default function MedalTable() {
    const { mirs_competition, mirs_language, mirs_discipline, mirs_gender, mirs_noc } = useUrlFriendlyToParameters()
    const params = useUrlFriendlyToParameters()
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, "medal")
    //copy parameters URL to change 
    //let paramsURL = { ...params }


    //Get Data
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['medalTable', mirs_competition, mirs_language],
            queryFn: getMedal,
            refetchInterval: 5000,
        });

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }
    if (!data?.medalNOC) { return <NotAvailable /> }


    const dataUpdate = JSON.parse(JSON.stringify(data?.medalNOC)); //Deep copy all elements primitive values (ineficiente??)
    //Si no hacemos lo anterior se repintara cada vez que se carguen los datos aunque estos no hayan cambiado  ya que los datos se pasan por refencia y los detactara como que hay cambios con lo anterior
    //Copy organisation data in every row data for  table

    dataUpdate?.forEach((item, index) => {
        item.participant = { organisation: { ...item.organisation } }
    });

    //Filters
    let dataFilter = dataUpdate//dataUpdate

    if (mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC) {
        dataFilter = dataFilter?.filter(item => item?.sport === mirs_discipline)
    } else {
        dataFilter = dataFilter?.filter(item => item?.sport === 'GLO')
    }

    if (mirs_noc && mirs_noc !== ALL_URL.ALL_NOC) {
        dataFilter = dataFilter?.filter(item => item?.participant?.organisation?.code === mirs_noc)
    }

    if (mirs_gender && mirs_gender !== "TOT") {
        dataFilter = dataFilter?.filter(item => item?.gender === mirs_gender)
    } else {
        dataFilter = dataFilter?.filter(item => item?.gender === 'TOT')
    }

    return (
        <>
            {/**
            <Form.Select aria-label="Default select example">
                <option>Open this select menu</option>
                <option value="1">Germany</option>
                <option value="2">France</option>
                <option value="3">Spain</option>
            </Form.Select>



            <Dropdown>
                <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                    Custom toggle
                </Dropdown.Toggle>

                <Dropdown.Menu as={CustomMenu}>
                    <Dropdown.Item eventKey="1">Red</Dropdown.Item>
                    <Dropdown.Item eventKey="2">Blue</Dropdown.Item>
                    <Dropdown.Item eventKey="3" active>
                        Orange
                    </Dropdown.Item>
                    <Dropdown.Item eventKey="1">Red-Orange</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>,
 */}

            <DrawComponent dataFilter={dataFilter} />
        </>
    )
};


function DrawComponent({ dataFilter }) {
    const columns = useMemo(() => getColumns(), []);

    return (
        <>
            <PageHeader title={Label({ data: 'MedalStandings' })} />

            <div className='mirs-page-container'>
                <Stack direction="horizontal" className="selectors-container">
                    <SelectorDiscipline display_type="combo" page="medal" />
                    <SelectorNoc page="medal" />
                    <SelectorGender page="medal" />
                </Stack>
                < MirsTable
                    id={'mirs-table-medal'}
                    data={dataFilter}
                    columns={columns}
                    showLoading={false}
                    initialSortBy={[{ id: 'Rank', desc: false }]}
                />
            </div>
        </>
    )
}

export function getColumns() {
    return (
        [
            ColumnRank({}),
            ColumnNoc({ accessor: 'organisation.code' }),
            ColumnOrganisation({}),
            ColumnGold(),
            ColumnSilver(),
            ColumnBronze(),
            ColumnTotal(),
            ColumnRankTotal(),

        ]
    )
}

function ColumnRank() {
    return (
        {
            Header: <Label data={"HeaderRank"} />,
            accessor: 'sortRank',
            className: "text-end",
            headerClassName: "text-end w-5 text-nowrap",
            disableSortBy: false,
            id: 'Rank',
            Cell: (props) => {
                return props.cell.row.original.rank
            }
        }
    )
}

function ColumnGold() {
    return (
        {
            Header: <Medal code={'1'} />,
            accessor: 'gold',
            className: "text-end",
            headerClassName: "medallist-medal text-end w-5 text-nowrap",
            disableSortBy: false,
            id: 'Gold',

        }
    )
}

function ColumnSilver() {
    return (
        {
            Header: <Medal code={'2'} />,
            accessor: 'silver',
            className: "text-end",
            headerClassName: "medallist-medal text-end w-5 text-nowrap",
            disableSortBy: false,
            id: 'Silver',

        }
    )
}

function ColumnBronze() {
    return (
        {
            Header: <Medal code={'3'} />,
            accessor: 'bronze',
            className: "text-end",
            headerClassName: "medallist-medal text-end w-5 text-nowrap",
            disableSortBy: false,
            id: 'Bronze',

        }
    )
}

function ColumnTotal() {
    return (
        {
            Header: <Label data={"HeaderTotal"} />,
            accessor: 'total',
            className: "text-end",
            headerClassName: "text-end w-5 text-nowrap",
            disableSortBy: false,
            id: 'Total',

        }
    )
}

function ColumnRankTotal() {
    return (
        {
            Header: <Label data={"RankByTotal"} />,
            accessor: 'sortRankTotal',
            className: "text-end",
            headerClassName: "text-end w-5",
            disableSortBy: false,
            id: 'RankByTotal',
            Cell: (props) => {
                return props.cell.row.original.rankTotal
            }
        }
    )
}

















